module.exports = __webpack_public_path__ + "static/media/yellow-arrow.eb89f14e.png";